import { sdeModel } from "./sde";
import { userModel } from "./user";
import { interact, URLS } from "fire-wind-water";
import { posterModel } from "./poster";
import { Subject } from "rxjs";
import { SdeData } from "./data";

class Goto {
  constructor() {
    this.seminar = null;
    this.user = null;
    this.posterInfo = null;
    this.tc = URLS.getURL("tc");
    this.markCode = URLS.getURL("markCode");
    this.markType = URLS.getURL("markType");
    this.isSetting = URLS.getURL("isSetting") == 1;
    this.instance = new SdeData();

    sdeModel.seminar.module(this);
    userModel.user.module(this);
    posterModel.poster.module(this);
  }

  skSeminarUserEnd(res) {
    console.log("用户信息", res);
    this.user = res;
  }

  skSeminarEnd(res) {
    console.log("会议信息", res);
    this.seminar = res;
  }

  skPosterEnd(res) {
    console.log("海报信息", res);
    this.posterInfo = res.wap;
  }

  login(s, b) {
    let url = interact.isMobile ? this.seminar.loginWap : this.seminar.login;
    url = URLS.updateSearchParam(
      "backUrl",
      encodeURIComponent(s || window.location.href),
      url
    );
    if (b) {
      return url;
    } else {
      if (this.isSetting) {
        return;
      }
      window.$sk.goto(url);
    }
  }
  // 默认跳转注册，可以根据配置来跳转注册/登录
  newLogin(s, b) {
    let url = interact.isMobile
      ? this.seminar.nowWapUrl
      : this.seminar.nowPcUrl;
    url = URLS.updateSearchParam(
      "backUrl",
      encodeURIComponent(s || window.location.href),
      url
    );
    if (b) {
      return url;
    } else {
      if (this.isSetting) {
        return;
      }
      window.$sk.goto(url);
    }
  }

  register(s, b) {
    let url = interact.isMobile
      ? this.seminar.registerWap
      : this.seminar.register;
    url = URLS.updateSearchParam(
      "backUrl",
      encodeURIComponent(s || window.location.href),
      url
    );
    if (b) {
      return url;
    } else {
      if (this.isSetting) {
        return;
      }
      window.$sk.goto(url);
    }
  }

  signUp(b) {
    let url = interact.isMobile ? this.seminar.signUpWap : this.seminar.signUp;
    let rurl = URLS.getURL("return_url", url);
    const markCode = this.user.markCode || this.markCode;
    const markType = this.markType;
    if (rurl) {
      rurl = decodeURIComponent(rurl);
      if (this.tc) {
        rurl = URLS.updateSearchParam("tc", this.tc, rurl);
      }
      if (markCode) {
        rurl = URLS.updateSearchParam("markCode", markCode, rurl);
      }
      if (markType) {
        rurl = URLS.updateSearchParam("markType", markType, rurl);
      }
      url = URLS.updateSearchParam("return_url", encodeURIComponent(rurl), url);
    } else {
      if (this.tc) {
        url = URLS.updateSearchParam("tc", this.tc, url);
      }
      if (markCode) {
        url = URLS.updateSearchParam("markCode", markCode, url);
      }
      if (markType) {
        url = URLS.updateSearchParam("markType", markType, url);
      }
    }
    if (b) {
      return url;
    } else {
      if (this.isSetting) {
        return;
      }
      window.$sk.goto(url);
    }
  }

  loginToSignUp(b) {
    const surl = this.signUp(true);
    const lurl = this.login(surl, true);
    if (b) {
      return lurl;
    } else {
      if (this.isSetting) {
        return;
      }
      window.$sk.goto(lurl);
    }
  }

  poster(b) {
    if (!this.posterInfo) {
      return null;
    }
    const m = window.$sk.template.get();
    const cs = `tenantId=${m.common.tenantId}&instanceId=${
      m.common.instanceId
    }&schemaId=${m.common.schemaId}&moduleId=3&weChatId=${
      this.seminar.weChatId || ""
    }`;
    let url = `${window.location.protocol}${this.posterInfo.formalUrl}index.html?${cs}#/`;
    const markCode = this.user.markCode || this.markCode;
    const markType = this.markType;
    if (markCode) {
      url = URLS.updateSearchParam("markCode", markCode, url);
    }
    if (markType) {
      url = URLS.updateSearchParam("markType", markType, url);
    }
    if (this.tc) {
      url = URLS.updateSearchParam("tc", this.tc, url);
    }
    if (b) {
      return url;
    } else {
      if (this.isSetting) {
        return;
      }
      window.$sk.goto(url);
    }
  }

  shortUrl(s) {
    const $s = new Subject();
    let url = null;
    switch (s) {
      case "poster":
        url = this.poster(true);
        break;
      case "signUp":
        url = this.signUp(true);
        break;
    }
    if (url) {
      this.instance.getShortUrl(url).subscribe((res) => {
        $s.next(res);
        $s.complete();
      });
    } else {
      $s.next(null);
      $s.complete();
    }

    return $s;
  }

  init() {}
}

const goto = new Goto();

export { goto };
